import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('armazem88_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      localStorage.setItem('armazem88_token', token);
      // Decode token to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ email: payload.sub });
      } catch {
        setUser(null);
        setToken(null);
        localStorage.removeItem('armazem88_token');
      }
    } else {
      localStorage.removeItem('armazem88_token');
      setUser(null);
    }
    setLoading(false);
  }, [token]);

  const login = (newToken, email) => {
    setToken(newToken);
    setUser({ email });
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('armazem88_token');
  };

  const isAuthenticated = !!token && !!user;

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
